<template>
  <div class="admin-page">
    <!-- Header -->
    <header class="header">
      <div class="header-content">
        <div class="brand">
          <div class="brand-badge">B</div>
          <div>
            <h1>BEZ Capital</h1>
            <div class="muted">后台管理系统</div>
          </div>
        </div>
        <div class="header-actions">
          <span class="user-email">{{ userEmail }}</span>
          <button class="btn-secondary" @click="handleLogout">退出登录</button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <div class="main-content">
      <div class="container">
        <!-- Tab Navigation -->
        <div class="tabs">
          <button
            v-for="tab in tabs"
            :key="tab.id"
            :class="['tab-btn', { active: activeTab === tab.id }]"
            @click="handleTabChange(tab.id)"
          >
            {{ tab.label }}
          </button>
        </div>

        <!-- Tab Content -->
        <div class="tab-content">
          <!-- Tab 1: 创建池子 -->
          <div v-show="activeTab === 'pool'" class="tab-panel">
            <div class="panel-header">
              <h2>创建策略池</h2>
              <p class="panel-desc">填写池子名称、初始金额、开始日期，并添加成员信息</p>
            </div>

            <div class="form-section">
              <div class="form-row">
                <div class="form-field">
                  <label>池子 ID *</label>
                  <input v-model="poolForm.pool_id" class="input" placeholder="例如: P001" />
                </div>
                <div class="form-field">
                  <label>池子名称 *</label>
                  <input v-model="poolForm.pool_name" class="input" placeholder="例如: 稳健增长策略池1" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label>开始日期 *</label>
                  <input v-model="poolForm.base_date" type="date" class="input" />
                </div>
                <div class="form-field">
                  <label>初始总金额 *</label>
                  <input v-model.number="poolForm.base_total" type="number" class="input" placeholder="0" readonly />
                  <small style="color: #888; display: block; margin-top: 4px;">初始总金额固定为0，后续通过"更新净值"功能来设置池子的总价值</small>
                </div>
              </div>

              <!-- <div class="form-field">
                <label>分配方式</label>
                <select v-model="poolForm.distribution_type" class="input">
                  <option value="weight">按权重分配</option>
                  <option value="amount">按金额分配</option>
                </select>
                <div class="field-hint">选择如何分配初始净值给成员</div>
              </div> -->
            </div>

            <!-- <div class="members-section">
              <div class="section-header">
                <h3>成员列表</h3>
                <button class="btn-add" @click="addMember">+ 添加成员</button>
              </div>

              <div class="members-table">
                <table>
                  <thead>
                    <tr>
                      <th>客户 ID</th>
                      <th>姓名</th>
                      <th>邮箱</th>
                      <th>权重</th>
                      <th>金额</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(member, index) in members" :key="index">
                      <td><input v-model="member.client_id" class="input-sm" placeholder="C001" /></td>
                      <td><input v-model="member.name" class="input-sm" placeholder="张三" /></td>
                      <td><input v-model="member.email" class="input-sm" placeholder="zhang@example.com" /></td>
                      <td><input v-model.number="member.weight" type="number" step="0.01" class="input-sm" placeholder="0.25" /></td>
                      <td><input v-model.number="member.amount" type="number" class="input-sm" placeholder="250000" /></td>
                      <td>
                        <button class="btn-delete" @click="removeMember(index)">删除</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->

            <div class="form-actions">
              <button class="btn-primary" @click="handleCreatePool">创建策略池</button>
            </div>

            <div v-if="poolError" class="alert alert-error">{{ poolError }}</div>
            <div v-if="poolSuccess" class="alert alert-success">{{ poolSuccess }}</div>
          </div>

          <!-- Tab 2: 每日更新净值 -->
          <div v-show="activeTab === 'nav'" class="tab-panel">
            <div class="panel-header">
              <h2>每日更新池子净值</h2>
              <p class="panel-desc">选择池子，输入日期和池子总价值，系统将自动计算净值并更新所有客户余额</p>
            </div>

            <div class="form-section">
              <div class="form-row">
                <div class="form-field">
                  <label>选择池子 *</label>
                  <select v-model="navForm.pool_id" class="input" @change="loadPoolClientsPreview">
                    <option value="">请选择池子</option>
                    <option v-for="pool in pools" :key="pool.pool_id" :value="pool.pool_id">
                      {{ pool.pool_id }} - {{ pool.name }}
                    </option>
                  </select>
                  <small v-if="selectedPool && selectedPool.lastNavUpdateDate" style="color: #888; display: block; margin-top: 4px;">
                    该池子最新更新日期：{{ selectedPool.lastNavUpdateDate }}
                  </small>
                </div>
                <div class="form-field">
                  <label>日期 *</label>
                  <input v-model="navForm.date" type="date" class="input" @change="loadPoolClientsPreview" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label>池子总价值 *</label>
                  <input v-model.number="navForm.total" type="number" step="0.01" class="input" placeholder="例如: 1100" />
                  <small style="color: #888; display: block; margin-top: 4px;">
                    💡 输入池子的总价值，系统将自动计算：池子净值 = 总价值 ÷ 总份额
                  </small>
                </div>
                <div class="form-field">
                  <label>分发规则</label>
                  <select v-model="navForm.rule" class="input">
                    <option value="amount">按金额分发</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="preview-section" v-if="poolClientsPreview && poolClientsPreview.length > 0">
              <h3>池子客户预览（截至 {{ navForm.date }}）</h3>
              <div class="total-summary">
                <div class="summary-item">
                  <span class="summary-label">客户数量：</span>
                  <span class="summary-value">{{ poolClientsPreview.length }} 人</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">总份额：</span>
                  <span class="summary-value primary">{{ calculateTotalShares() }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">已计算份额的总余额：</span>
                  <span class="summary-value primary">{{ formatCurrency(calculateCalculatedBalance()) }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">未计算份额的投入金额：</span>
                  <span class="summary-value warning">{{ formatCurrency(calculateUncalculatedInvestment()) }}</span>
                </div>
                <div class="summary-item">
                  <span class="summary-label">建议池子总价值：</span>
                  <span class="summary-value highlight">{{ formatCurrency(calculateSuggestedTotalValue()) }}</span>
                </div>
                <div class="summary-item" v-if="navForm.total > 0">
                  <span class="summary-label">池子净值：</span>
                  <span class="summary-value highlight">{{ calculatePoolNav() }}</span>
                </div>
              </div>

              <div class="preview-table">
                <table>
                  <thead>
                    <tr>
                      <th>客户 ID</th>
                      <th>姓名</th>
                      <th>加入时间</th>
                      <th>投入金额</th>
                      <th>持有份额</th>
                      <th>当前余额</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="client in poolClientsPreview" :key="client.clientId">
                      <td>{{ client.clientId }}</td>
                      <td>{{ client.name || '-' }}</td>
                      <td>{{ client.joinDate || '-' }}</td>
                      <td>{{ formatCurrency(client.initialAmount) }}</td>
                      <td>{{ client.shares ? client.shares.toFixed(2) : '-' }}</td>
                      <td>{{ formatCurrency(client.balance) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="form-actions">
              <button class="btn-primary" @click="handleSubmitNav">提交净值</button>
              <button class="btn-danger" @click="handleRollbackNav" style="margin-left: 12px;">撤回最近一次更新</button>
            </div>

            <div v-if="navError" class="alert alert-error">{{ navError }}</div>
            <div v-if="navSuccess" class="alert alert-success">{{ navSuccess }}</div>
          </div>

          <!-- Tab 3: 客户管理 -->
          <div v-show="activeTab === 'clients'" class="tab-panel">
            <div class="panel-header">
              <h2>客户账户管理</h2>
              <p class="panel-desc">创建或编辑客户账户信息</p>
            </div>

            <div class="form-section">
              <div class="form-row">
                <div class="form-field">
                  <label>客户 ID *</label>
                  <input v-model="clientForm.client_id" class="input" placeholder="C001" />
                </div>
                <div class="form-field">
                  <label>姓名 *</label>
                  <input v-model="clientForm.name" class="input" placeholder="张三" />
                </div>
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label>邮箱 *</label>
                  <input v-model="clientForm.email" type="email" class="input" placeholder="zhang@example.com" />
                </div>
                <!-- <div class="form-field">
                  <label>手机号 *</label>
                  <input v-model="clientForm.phone" type="tel" class="input" placeholder="13800138000" maxlength="11" />
                </div> -->
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label>初始密码</label>
                  <input v-model="clientForm.password" type="password" class="input" placeholder="留空则使用默认密码" />
                </div>
                <!-- <div class="form-field">
                  <label>所属池子（可选）</label>
                  <select v-model="clientForm.pool_id" class="input">
                    <option value="">不分配到池子</option>
                    <option v-for="pool in pools" :key="pool.pool_id" :value="pool.pool_id">
                      {{ pool.pool_id }} - {{ pool.name }}
                    </option>
                  </select>
                </div> -->
              </div>

              <div class="form-row">
                <div class="form-field">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="clientForm.createUser" />
                    <span>创建用户账号</span>
                  </label>
                  <small style="color: var(--muted); margin-left: 24px;">勾选后将为该客户创建登录账号</small>
                </div>
              </div>
            </div>

            <div class="form-actions">
              <button class="btn-primary" @click="handleCreateClient">
                {{ editingClientId ? '更新客户' : '创建客户' }}
              </button>
              <button v-if="editingClientId" class="btn-secondary" @click="cancelEditClient">
                取消编辑
              </button>
            </div>

            <div v-if="clientError" class="alert alert-error">{{ clientError }}</div>
            <div v-if="clientSuccess" class="alert alert-success">{{ clientSuccess }}</div>

            <!-- 客户列表 -->
            <div class="clients-list">
              <div class="list-header">
                <h3>现有客户</h3>
                <div class="search-box">
                  <input
                    v-model="clientSearch.keyword"
                    type="text"
                    class="input search-input"
                    placeholder="搜索客户名字或手机号..."
                    @input="handleClientSearch"
                  />
                  <button v-if="clientSearch.keyword" class="btn-clear" @click="clearClientSearch">
                    ✕
                  </button>
                </div>
              </div>

              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>客户 ID</th>
                      <th>姓名</th>
                      <th>邮箱</th>
                      <!-- <th>手机号</th> -->
                      <th>所属池子</th>
                      <th>加入日期</th>
                      <th>当前金额</th>
                      <th>持有份额</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="clientsList.length === 0">
                      <td colspan="9" style="text-align: center; padding: 40px; color: #999;">
                        {{ clientSearch.keyword ? '没有找到匹配的客户' : '暂无客户数据' }}
                      </td>
                    </tr>
                    <tr v-for="client in clientsList" :key="client.client_id">
                      <td>{{ client.client_id }}</td>
                      <td>{{ client.name }}</td>
                      <td>{{ client.email }}</td>
                      <!-- <td>{{ client.phone || '-' }}</td> -->
                      <td>{{ client.pools || '-' }}</td>
                      <td>{{ client.joinDate || '-' }}</td>
                      <td>
                        <span class="balance-amount">{{ formatCurrency(client.balance || 0) }}</span>
                      </td>
                      <td>
                        <span class="shares-amount">{{ formatShares(client.shares || 0) }}</span>
                      </td>
                      <td>
                        <div class="action-buttons">
                          <button class="btn-edit" @click="editClient(client)">编辑</button>
                          <button class="btn-join-pool" @click="openJoinPoolModal(client)" v-if="!client.pools || client.pools === '-'">加入池子</button>
                          <button class="btn-add-investment" @click="openJoinPoolModal(client)" v-if="client.pools && client.pools !== '-'">追加投入</button>
                          <!-- <button class="btn-redeem" @click="openRedeemModal(client)" v-if="client.pools && client.pools !== '-'">赎回</button> -->
                          <!-- <button class="btn-adjust" @click="openAdjustBalance(client)">调整金额</button> -->
                          <button class="btn-delete" @click="deleteClient(client.client_id)">删除</button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="clientsList.length === 0">
                      <td colspan="9" style="text-align: center; color: var(--muted);">暂无客户数据</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 分页组件 -->
              <div v-if="clientPagination.totalElements > 0" class="pagination">
                <button
                  class="pagination-btn"
                  :disabled="clientPagination.pageNumber === 0"
                  @click="goToClientPage(0)"
                >
                  首页
                </button>
                <button
                  class="pagination-btn"
                  :disabled="clientPagination.pageNumber === 0"
                  @click="goToClientPage(clientPagination.pageNumber - 1)"
                >
                  上一页
                </button>

                <span class="pagination-info">
                  第 {{ clientPagination.pageNumber + 1 }} / {{ clientPagination.totalPages }} 页
                  （共 {{ clientPagination.totalElements }} 条记录）
                </span>

                <button
                  class="pagination-btn"
                  :disabled="clientPagination.pageNumber >= clientPagination.totalPages - 1"
                  @click="goToClientPage(clientPagination.pageNumber + 1)"
                >
                  下一页
                </button>
                <button
                  class="pagination-btn"
                  :disabled="clientPagination.pageNumber >= clientPagination.totalPages - 1"
                  @click="goToClientPage(clientPagination.totalPages - 1)"
                >
                  末页
                </button>

                <select v-model.number="clientPagination.pageSize" class="page-size-select" @change="changeClientPageSize">
                  <option :value="5">5条/页</option>
                  <option :value="10">10条/页</option>
                  <option :value="20">20条/页</option>
                  <option :value="50">50条/页</option>
                </select>
              </div>
            </div>
          </div>

          <!-- 金额调整模态框 -->
          <div v-if="showAdjustModal" class="modal-overlay" @click="closeAdjustModal">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <h3>调整客户金额</h3>
                <button class="modal-close" @click="closeAdjustModal">×</button>
              </div>
              <div class="modal-body">
                <div class="client-info-display">
                  <p><strong>客户：</strong>{{ adjustingClient?.name }} ({{ adjustingClient?.client_id }})</p>
                  <p><strong>当前金额：</strong>{{ formatCurrency(adjustingClient?.balance || 0) }}</p>
                </div>

                <div class="form-field">
                  <label>调整类型 *</label>
                  <div class="adjust-type-buttons">
                    <button
                      :class="['type-btn', { active: adjustType === 'add' }]"
                      @click="adjustType = 'add'"
                    >
                      ➕ 增加金额
                    </button>
                    <button
                      :class="['type-btn', { active: adjustType === 'subtract' }]"
                      @click="adjustType = 'subtract'"
                    >
                      ➖ 减少金额
                    </button>
                  </div>
                </div>

                <div class="form-field">
                  <label>调整金额 *</label>
                  <input
                    v-model.number="adjustAmount"
                    type="number"
                    class="input"
                    placeholder="请输入金额"
                    min="0"
                    step="0.01"
                  />
                </div>

                <div class="form-field">
                  <label>备注（可选）</label>
                  <textarea
                    v-model="adjustRemark"
                    class="input"
                    placeholder="请输入调整原因或备注"
                    rows="3"
                  ></textarea>
                </div>

                <div class="info-box" style="background: #f0f9ff; border: 1px solid #0ea5e9; padding: 12px; border-radius: 6px; margin-top: 12px;">
                  <p style="color: #0369a1; font-size: 14px; margin: 0;">
                    💡 提示：调整余额后，份额将在下次更新净值时自动计算
                  </p>
                </div>

                <div v-if="adjustType && adjustAmount > 0" class="preview-result">
                  <p>
                    <strong>调整后金额：</strong>
                    <span :class="adjustType === 'add' ? 'positive' : 'negative'">
                      {{ formatCurrency(calculateNewBalance()) }}
                    </span>
                  </p>
                </div>

                <div v-if="adjustError" class="alert alert-error">{{ adjustError }}</div>
              </div>
              <div class="modal-footer">
                <button class="btn-secondary" @click="closeAdjustModal">取消</button>
                <button class="btn-primary" @click="handleAdjustBalance">确认调整</button>
              </div>
            </div>
          </div>

          <!-- 加入池子/追加投入模态框 -->
          <div v-if="showJoinPoolModal" class="modal-overlay" @click="closeJoinPoolModal">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <h3>{{ isAddingInvestment ? '追加投入' : '客户加入池子' }}</h3>
                <button class="modal-close" @click="closeJoinPoolModal">×</button>
              </div>

              <div class="modal-body">
                <div v-if="joinPoolError" class="alert alert-error">{{ joinPoolError }}</div>

                <div class="form-group">
                  <label>客户信息</label>
                  <div class="info-display">
                    <p><strong>客户ID:</strong> {{ joiningClient?.client_id }}</p>
                    <p><strong>姓名:</strong> {{ joiningClient?.name }}</p>
                    <p><strong>当前余额:</strong> {{ formatCurrency(joiningClient?.balance || 0) }}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>选择池子 <span class="required">*</span></label>
                  <select v-model="joinPoolForm.poolId" class="input" required>
                    <option value="">请选择池子</option>
                    <option v-for="pool in poolsList" :key="pool.poolId" :value="pool.poolId">
                      {{ pool.poolId }} - {{ pool.name }} (当前净值: {{ (pool.currentNavValue || 1.0).toFixed(2) }})
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label>加入日期 <span class="required">*</span></label>
                  <input
                    v-model="joinPoolForm.joinDate"
                    type="date"
                    class="input"
                    required
                  />
                </div>

                <div class="form-group">
                  <label>投入金额 <span class="required">*</span></label>
                  <input
                    v-model.number="joinPoolForm.amount"
                    type="number"
                    step="0.01"
                    min="0"
                    class="input"
                    placeholder="请输入投入金额"
                    required
                  />
                </div>

                <div class="info-box" style="background: #f0f9ff; border: 1px solid #0ea5e9; padding: 12px; border-radius: 6px; margin-top: 12px;">
                  <p style="color: #0369a1; font-size: 14px; margin: 0;">
                    💡 提示：{{ isAddingInvestment ? '追加投入后，将根据当前池子净值计算新增份额，累加到总份额中。' : '客户加入池子后，将根据当前池子净值计算份额。份额一旦确定，将固定不变。' }}
                  </p>
                  <p v-if="joinPoolForm.poolId && joinPoolForm.amount > 0" style="color: #0369a1; font-size: 14px; margin: 8px 0 0 0;">
                    <strong>{{ isAddingInvestment ? '新增份额' : '预计份额' }}:</strong> {{ calculateExpectedShares() }}
                  </p>
                  <p v-if="isAddingInvestment && joiningClient" style="color: #0369a1; font-size: 14px; margin: 8px 0 0 0;">
                    <strong>当前总份额:</strong> {{ parseFloat(joiningClient.shares || 0).toFixed(2) }}
                  </p>
                  <p v-if="isAddingInvestment && joiningClient && joinPoolForm.amount > 0" style="color: #0369a1; font-size: 14px; margin: 8px 0 0 0;">
                    <strong>追加后总份额:</strong> {{ (parseFloat(joiningClient.shares || 0) + parseFloat(calculateExpectedShares())).toFixed(2) }}
                  </p>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn-secondary" @click="closeJoinPoolModal">取消</button>
                <button class="btn-primary" @click="confirmJoinPool" :disabled="!joinPoolForm.poolId || !joinPoolForm.amount || joinPoolForm.amount <= 0">
                  {{ isAddingInvestment ? '确认追加' : '确认加入' }}
                </button>
              </div>
            </div>
          </div>

          <!-- 赎回模态框 -->
          <div v-if="showRedeemModal" class="modal-overlay" @click="closeRedeemModal">
            <div class="modal-content" @click.stop>
              <div class="modal-header">
                <h3>客户赎回</h3>
                <button class="modal-close" @click="closeRedeemModal">×</button>
              </div>

              <div class="modal-body">
                <div v-if="redeemError" class="alert alert-error">{{ redeemError }}</div>

                <div class="form-group">
                  <label>客户信息</label>
                  <div class="info-display">
                    <p><strong>客户ID:</strong> {{ redeemingClient?.client_id }}</p>
                    <p><strong>姓名:</strong> {{ redeemingClient?.name }}</p>
                    <p><strong>当前余额:</strong> {{ formatCurrency(redeemingClient?.balance || 0) }}</p>
                    <p><strong>当前份额:</strong> {{ redeemingClient?.shares || 0 }}</p>
                    <p><strong>所属池子:</strong> {{ redeemingClient?.pools || '-' }}</p>
                  </div>
                </div>

                <div class="form-group">
                  <label>赎回金额 *</label>
                  <input
                    type="number"
                    v-model.number="redeemForm.amount"
                    placeholder="请输入赎回金额"
                    step="0.01"
                    min="0"
                    :max="redeemingClient?.balance || 0"
                  />
                </div>

                <div class="info-box">
                  <p>💡 提示：赎回后，将根据当前池子净值计算减少的份额。</p>
                  <p v-if="redeemForm.amount > 0">
                    <strong>预计减少份额:</strong> {{ calculateRedeemShares() }}
                  </p>
                  <p v-if="redeemingClient && redeemForm.amount > 0">
                    <strong>剩余份额:</strong> {{ (parseFloat(redeemingClient.shares || 0) - parseFloat(calculateRedeemShares())).toFixed(2) }}
                  </p>
                  <p v-if="redeemingClient && redeemForm.amount > 0">
                    <strong>剩余余额:</strong> {{ formatCurrency((redeemingClient.balance || 0) - redeemForm.amount) }}
                  </p>
                </div>
              </div>

              <div class="modal-footer">
                <button class="btn-secondary" @click="closeRedeemModal">取消</button>
                <button class="btn-primary" @click="confirmRedeem" :disabled="!redeemForm.amount || redeemForm.amount <= 0 || redeemForm.amount > (redeemingClient?.balance || 0)">
                  确认赎回
                </button>
              </div>
            </div>
          </div>

          <!-- Tab 4: 查看净值记录 -->
          <div v-show="activeTab === 'records'" class="tab-panel">
            <div class="panel-header">
              <h2>净值记录</h2>
              <p class="panel-desc">查看历史净值更新记录，支持导出和刷新</p>
            </div>

            <div class="records-section">
              <div class="section-header">
                <h3>池净值记录</h3>
                <button class="btn-secondary" @click="refreshPoolNavLogs">刷新</button>
              </div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>池子 ID</th>
                      <th>日期</th>
                      <th>总价值</th>
                      <th>总份额</th>
                      <th>净值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, index) in poolNavLogs" :key="index">
                      <td>{{ log.poolId }}</td>
                      <td>{{ log.date }}</td>
                      <td>{{ formatCurrency(log.totalValue) }}</td>
                      <td>{{ log.totalShares ? log.totalShares.toFixed(2) : '-' }}</td>
                      <td>{{ log.navValue ? log.navValue.toFixed(2) : '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- 池净值记录分页 -->
              <div class="pagination">
                <div class="pagination-info">
                  共 {{ poolNavPagination.totalElements }} 条记录，第 {{ poolNavPagination.pageNumber + 1 }} / {{ poolNavPagination.totalPages }} 页
                </div>
                <div class="pagination-controls">
                  <button
                    @click="goToPoolNavPage(0)"
                    :disabled="poolNavPagination.pageNumber === 0"
                    class="btn-secondary">
                    首页
                  </button>
                  <button
                    @click="goToPoolNavPage(poolNavPagination.pageNumber - 1)"
                    :disabled="poolNavPagination.pageNumber === 0"
                    class="btn-secondary">
                    上一页
                  </button>
                  <button
                    @click="goToPoolNavPage(poolNavPagination.pageNumber + 1)"
                    :disabled="poolNavPagination.pageNumber >= poolNavPagination.totalPages - 1"
                    class="btn-secondary">
                    下一页
                  </button>
                  <button
                    @click="goToPoolNavPage(poolNavPagination.totalPages - 1)"
                    :disabled="poolNavPagination.pageNumber >= poolNavPagination.totalPages - 1"
                    class="btn-secondary">
                    末页
                  </button>
                  <select v-model.number="poolNavPagination.pageSize" @change="changePoolNavPageSize" class="page-size-select">
                    <option :value="10">10条/页</option>
                    <option :value="20">20条/页</option>
                    <option :value="50">50条/页</option>
                    <option :value="100">100条/页</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="records-section">
              <div class="section-header">
                <h3>客户净值记录</h3>
              </div>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      <th>客户 ID</th>
                      <th>池子 ID</th>
                      <th>日期</th>
                      <th>余额</th>
                      <th>个人净值</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(log, index) in clientNavLogs" :key="index">
                      <td>{{ log.clientId }}</td>
                      <td>{{ log.poolId || '-' }}</td>
                      <td>{{ log.date }}</td>
                      <td>{{ formatCurrency(log.balance) }}</td>
                      <td>{{ log.personalNavValue ? (log.personalNavValue+ 1 ).toFixed(2) : '-' }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- 客户净值记录分页 -->
              <div class="pagination">
                <div class="pagination-info">
                  共 {{ clientNavPagination.totalElements }} 条记录，第 {{ clientNavPagination.pageNumber + 1 }} / {{ clientNavPagination.totalPages }} 页
                </div>
                <div class="pagination-controls">
                  <button
                    @click="goToClientNavPage(0)"
                    :disabled="clientNavPagination.pageNumber === 0"
                    class="btn-secondary">
                    首页
                  </button>
                  <button
                    @click="goToClientNavPage(clientNavPagination.pageNumber - 1)"
                    :disabled="clientNavPagination.pageNumber === 0"
                    class="btn-secondary">
                    上一页
                  </button>
                  <button
                    @click="goToClientNavPage(clientNavPagination.pageNumber + 1)"
                    :disabled="clientNavPagination.pageNumber >= clientNavPagination.totalPages - 1"
                    class="btn-secondary">
                    下一页
                  </button>
                  <button
                    @click="goToClientNavPage(clientNavPagination.totalPages - 1)"
                    :disabled="clientNavPagination.pageNumber >= clientNavPagination.totalPages - 1"
                    class="btn-secondary">
                    末页
                  </button>
                  <select v-model.number="clientNavPagination.pageSize" @change="changeClientNavPageSize" class="page-size-select">
                    <option :value="10">10条/页</option>
                    <option :value="20">20条/页</option>
                    <option :value="50">50条/页</option>
                    <option :value="100">100条/页</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '../api'

export default {
  name: 'AdminPage',
  data() {
    // 获取今天的日期
    const today = new Date()
    const year = today.getFullYear()
    const month = String(today.getMonth() + 1).padStart(2, '0')
    const day = String(today.getDate()).padStart(2, '0')
    const todayDate = `${year}-${month}-${day}`

    return {
      userEmail: '',
      activeTab: 'pool',
      tabs: [
        { id: 'pool', label: '创建池子' },
        { id: 'nav', label: '更新净值' },
        { id: 'clients', label: '客户管理' },
        { id: 'records', label: '净值记录' }
      ],
      // 创建池表单
      poolForm: {
        pool_id: '',
        pool_name: '',
        base_date: '',
        base_total: 0,
        distribution_type: 'weight'
      },
      members: [],
      poolError: '',
      poolSuccess: '',
      // 净值表单
      navForm: {
        pool_id: '',
        date: todayDate, // 默认为今天
        total: 0,
        rule: 'amount' // 默认选择"按金额分发"
      },
      navError: '',
      navSuccess: '',
      // 客户表单
      clientForm: {
        client_id: '',
        name: '',
        email: '',
        phone: '13800000000',
        password: '',
        pool_id: '',
        createUser: false
      },
      editingClientId: null, // 正在编辑的客户ID
      clientError: '',
      clientSuccess: '',
      // 客户搜索和分页
      clientSearch: {
        keyword: '',
        timer: null
      },
      clientPagination: {
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      },
      // 金额调整相关
      showAdjustModal: false,
      adjustingClient: null,
      adjustType: 'add', // 'add' or 'subtract'
      adjustAmount: 0,
      adjustRemark: '',
      adjustPoolId: '', // 池子ID（用于份额计算）
      adjustNavValue: 1.0, // 当前净值（用于份额计算）
      adjustError: '',
      // 加入池子相关
      showJoinPoolModal: false,
      joiningClient: null,
      joinPoolForm: {
        poolId: '',
        joinDate: todayDate,  // 默认为今天
        amount: 0
      },
      joinPoolError: '',
      // 赎回相关
      showRedeemModal: false,
      redeemingClient: null,
      redeemForm: {
        amount: 0
      },
      redeemError: '',
      // 数据
      pools: [],
      selectedPool: null, // 当前选中的池子
      membersSummary: null, // 成员汇总信息（包括总金额）
      poolClientsPreview: [], // 池子客户预览列表
      clientsList: [],
      // 池净值记录分页
      poolNavLogs: [],
      poolNavPagination: {
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      },
      // 客户净值记录分页
      clientNavLogs: [],
      clientNavPagination: {
        pageNumber: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0
      }
    }
  },
  async mounted() {
    await this.checkAuth()
    await this.loadPools() // ✅ 已接入后端 API
    this.addMember() // 添加一个空成员行
  },
  computed: {
    poolsList() {
      return this.pools || []
    },
    isAddingInvestment() {
      // 如果客户已经在池子中，则为追加投入
      return this.joiningClient && this.joiningClient.pools && this.joiningClient.pools !== '-'
    }
  },
  methods: {
    // 获取今天的日期（YYYY-MM-DD 格式）
    getTodayDate() {
      const today = new Date()
      const year = today.getFullYear()
      const month = String(today.getMonth() + 1).padStart(2, '0')
      const day = String(today.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    // 格式化货币 - 保留一位小数并四舍五入
    formatCurrency(value) {
      if (value === null || value === undefined || value === '-') {
        return '-'
      }
      // 金额保留一位小数并四舍五入
      return '$' + parseFloat(value).toFixed(1)
    },
    async checkAuth() {
      // 检查后端 JWT 登录
      const token = localStorage.getItem('authToken')
      const userInfo = localStorage.getItem('userInfo')

      if (!token || !userInfo) {
        this.$router.push('/login')
        return
      }

      const user = JSON.parse(userInfo)
      console.log('✅ 检测到已登录:', user.name)
      this.userEmail = user.email

      // 检查是否是管理员
      if (user.role !== 'ADMIN') {
        this.$router.push('/dashboard')
      }
    },
    async handleLogout() {
      // 清除登录状态
      localStorage.removeItem('authToken')
      localStorage.removeItem('userInfo')

      this.$router.push('/login')
    },
    addMember() {
      this.members.push({ client_id: '', name: '', email: '', weight: null, amount: null })
    },
    removeMember(index) {
      this.members.splice(index, 1)
    },
    async loadPools() {
      try {
        const response = await api.getAllPools()
        if (response.success) {
          this.pools = response.data.map(pool => ({
            pool_id: pool.poolId,
            poolId: pool.poolId,
            name: pool.name,
            currentNavValue: pool.currentNavValue,
            lastNavUpdateDate: pool.lastNavUpdateDate
          }))
          console.log('✅ 加载策略池成功，共', this.pools.length, '个池子')
        }
      } catch (error) {
        console.error('❌ 加载策略池失败:', error)
      }
    },
    async loadClients(page = null) {
      try {
        // 使用传入的页码，如果没有则使用当前页码
        const currentPage = page !== null ? page : this.clientPagination.pageNumber

        const response = await api.getClientsPage(
          currentPage,
          this.clientPagination.pageSize,
          this.clientSearch.keyword
        )

        if (response.success) {
          const pageData = response.data

          // 更新客户列表
          this.clientsList = pageData.content.map(client => ({
            id: client.id,
            client_id: client.clientId,
            name: client.name,
            email: client.email,
            phone: client.phone,
            balance: client.balance,
            shares: client.shares,  // 添加份额字段
            user_id: client.userId,
            pools: client.poolIds && client.poolIds.length > 0 ? client.poolIds.join(', ') : '-',
            joinDate: client.joinDate  // 添加加入日期字段
          }))

          // 更新分页信息
          this.clientPagination = {
            pageNumber: pageData.pageNumber,
            pageSize: pageData.pageSize,
            totalElements: pageData.totalElements,
            totalPages: pageData.totalPages
          }

          console.log('✅ 加载客户列表成功，共', pageData.totalElements, '个客户，当前第', pageData.pageNumber + 1, '页')
        }
      } catch (error) {
        console.error('❌ 加载客户列表失败:', error)
        this.clientError = '加载客户列表失败'
      }
    },
    async handleTabChange(tabId) {
      this.activeTab = tabId

      // 每次切换tab都重新加载最新数据
      if (tabId === 'pool') {
        // 创建池子 tab - 加载池子列表
        await this.loadPools()
      } else if (tabId === 'nav') {
        // 更新净值 tab - 加载池子列表
        await this.loadPools()
        // 清空之前的预览数据
        this.poolClientsPreview = []
      } else if (tabId === 'clients') {
        // 客户管理 tab - 重新加载客户列表和池子列表
        await this.loadPools()
        // 重置搜索和分页
        this.clientSearch.keyword = ''
        this.clientPagination.pageNumber = 0
        await this.loadClients(0)
      } else if (tabId === 'records') {
        // 净值记录 tab - 重新加载净值记录
        await this.loadPoolNavRecords(0)
        await this.loadClientNavRecords(0)
      }
    },
    // 客户搜索
    handleClientSearch() {
      // 清除之前的定时器
      if (this.clientSearch.timer) {
        clearTimeout(this.clientSearch.timer)
      }

      // 设置新的定时器，延迟500ms执行搜索
      this.clientSearch.timer = setTimeout(() => {
        this.clientPagination.pageNumber = 0 // 重置到第一页
        this.loadClients(0)
      }, 500)
    },
    clearClientSearch() {
      this.clientSearch.keyword = ''
      this.clientPagination.pageNumber = 0
      this.loadClients(0)
    },
    // 分页操作
    goToClientPage(page) {
      this.loadClients(page)
    },
    changeClientPageSize() {
      this.clientPagination.pageNumber = 0 // 重置到第一页
      this.loadClients(0)
    },
    async loadPoolClientsPreview() {
      if (!this.navForm.pool_id) {
        this.poolClientsPreview = []
        this.selectedPool = null
        return
      }

      try {
        // 从pools数组中找到选中的池子
        this.selectedPool = this.pools.find(pool => pool.poolId === this.navForm.pool_id)

        // 调用后端接口获取池子的所有客户
        const response = await api.getPoolClients(this.navForm.pool_id)

        if (response.success && response.data) {
          // 根据选择的日期过滤客户：只显示加入日期 <= 所选日期的客户
          const selectedDate = this.navForm.date
          if (selectedDate) {
            this.poolClientsPreview = response.data.filter(client => {
              // 如果客户没有加入日期，则显示
              if (!client.joinDate) return true
              // 只显示加入日期 <= 所选日期的客户
              return client.joinDate <= selectedDate
            })
            console.log(`✅ 加载池子 ${this.navForm.pool_id} 的客户预览，共 ${response.data.length} 个客户，过滤后 ${this.poolClientsPreview.length} 个客户（加入日期 <= ${selectedDate}）`)
          } else {
            // 如果没有选择日期，显示所有客户
            this.poolClientsPreview = response.data
            console.log(`✅ 加载池子 ${this.navForm.pool_id} 的客户预览，共 ${this.poolClientsPreview.length} 个客户`)
          }
        } else {
          this.poolClientsPreview = []
          console.log(`⚠️ 池子 ${this.navForm.pool_id} 暂无客户`)
        }
      } catch (error) {
        console.error('❌ 加载池子客户预览失败:', error)
        this.poolClientsPreview = []
      }
    },
    calculateTotalShares() {
      if (!this.poolClientsPreview || this.poolClientsPreview.length === 0) {
        return '0.00'
      }
      const total = this.poolClientsPreview.reduce((sum, client) => sum + (client.shares || 0), 0)
      return total.toFixed(2)
    },
    calculateTotalBalance() {
      if (!this.poolClientsPreview || this.poolClientsPreview.length === 0) {
        return 0
      }
      return this.poolClientsPreview.reduce((sum, client) => sum + (client.balance || 0), 0)
    },
    // 计算已计算份额的客户总余额 (shares > 0)
    calculateCalculatedBalance() {
      if (!this.poolClientsPreview || this.poolClientsPreview.length === 0) {
        return 0
      }
      return this.poolClientsPreview
        .filter(client => client.shares > 0)
        .reduce((sum, client) => sum + (client.balance || 0), 0)
    },
    // 计算未计算份额的客户投入金额 (shares = 0)
    calculateUncalculatedInvestment() {
      if (!this.poolClientsPreview || this.poolClientsPreview.length === 0) {
        return 0
      }
      return this.poolClientsPreview
        .filter(client => !client.shares || client.shares === 0)
        .reduce((sum, client) => sum + (client.initialAmount || 0), 0)
    },
    // 计算建议的池子总价值 (已计算份额的余额 + 未计算份额的投入)
    calculateSuggestedTotalValue() {
      return this.calculateCalculatedBalance() + this.calculateUncalculatedInvestment()
    },
    calculatePoolNav() {
      const totalShares = parseFloat(this.calculateTotalShares())
      const totalValue = this.navForm.total || 0

      if (totalShares <= 0 || totalValue <= 0) {
        return '0.00'
      }

      const poolNav = totalValue / totalShares
      // 净值保留两位小数并四舍五入
      return poolNav.toFixed(2)
    },
    async handleCreatePool() {
      this.poolError = ''
      this.poolSuccess = ''

      const { pool_id, pool_name, base_date, base_total } = this.poolForm
      if (!pool_id || !pool_name) {
        this.poolError = '请完整填写池ID和池名称'
        return
      }

      const validMembers = this.members.filter(m => m.client_id && m.client_id.trim())

      try {
        // 1. 创建或更新客户（如果有成员）
        if (validMembers.length) {
          for (const member of validMembers) {
            try {
              // 检查客户是否存在
              const checkResponse = await api.getClientByClientId(member.client_id)
              if (!checkResponse.success) {
                // 客户不存在，创建新客户并同时创建用户账号
                await api.createClient({
                  clientId: member.client_id,  // 指定客户 ID
                  name: member.name,
                  email: member.email,
                  phone: member.phone || '',
                  balance: member.amount || 0,
                  createUser: true,  // 同时创建用户账号
                  password: '123456'  // 默认密码
                })
              }
            } catch (error) {
              // 如果是404错误，说明客户不存在，创建新客户并同时创建用户账号
              if (error.response?.status === 404) {
                await api.createClient({
                  clientId: member.client_id,  // 指定客户 ID
                  name: member.name,
                  email: member.email,
                  phone: member.phone || '',
                  balance: member.amount || 0,
                  createUser: true,  // 同时创建用户账号
                  password: '123456'  // 默认密码
                })
              } else {
                throw error
              }
            }
          }
        }

        // 2. 创建策略池
        // 注意：axios 响应拦截器已经解包了 response.data，所以这里直接是 { success, message, data }
        const poolResponse = await api.createPool({
          poolId: pool_id,
          name: pool_name,
          description: pool_name,  // 使用池子名称作为描述
          totalNav: base_total || 0,
          startDate: base_date  // 发送开始日期
        })

        if (!poolResponse || !poolResponse.success) {
          throw new Error(poolResponse?.message || '创建策略池失败')
        }

        console.log('✅ 策略池创建成功:', poolResponse.data)

        // 3. 创建初始净值记录（如果有成员和初始金额）
        if (validMembers.length && base_total > 0 && base_date) {
          const sumWeight = validMembers.reduce((s, r) => s + (r.weight || 0), 0)
          const sumAmount = validMembers.reduce((s, r) => s + (r.amount || 0), 0)
          const useWeight = sumWeight > 0

          const navRecords = validMembers.map(r => {
            const portion = useWeight
              ? ((r.weight || 0) / (sumWeight || 1))
              : ((r.amount || 0) / (sumAmount || 1))
            return {
              clientId: r.client_id,
              poolId: pool_id,
              date: base_date,
              navAmount: Math.round(base_total * portion),
              dailyChange: 0,
              returnRate: 0
            }
          })

          console.log('准备创建净值记录:', navRecords)

          // 注意：api.createNavRecordsBatch 会自动包装成 { records: navRecords }
          await api.createNavRecordsBatch(navRecords)
        }

        this.poolSuccess = `✓ 成功创建池子 ${pool_id}${base_date ? '，基准日净值已写入' : ''}`
        await this.loadPools()

        // 清空表单
        this.poolForm = { pool_id: '', pool_name: '', base_date: '', base_total: 0, allocation_type: 'weight' }
        this.members = []
        this.addMember()
      } catch (e) {
        console.error('创建池子失败:', e)
        this.poolError = e.response?.data?.message || e.message || '创建失败，请检查输入'
      }
    },
    async handleSubmitNav() {
      this.navError = ''
      this.navSuccess = ''

      const { pool_id, date, total } = this.navForm
      if (!pool_id || !date || total <= 0) {
        this.navError = '请完整填写池子、日期和池子总价值'
        return
      }

      try {
        // 检查是否有客户在该日期或之前加入
        if (!this.poolClientsPreview || this.poolClientsPreview.length === 0) {
          this.navError = '当时没有已加入的客户，无法更新净值'
          return
        }

        // 计算当时已加入客户的总份额
        const totalSharesAtDate = parseFloat(this.calculateTotalShares())

        console.log('📊 提交池子净值更新:', {
          poolId: pool_id,
          date,
          totalValue: total,
          totalSharesAtDate: totalSharesAtDate,
          clientCount: this.poolClientsPreview.length
        })

        // 调用后端API创建池子净值记录
        // 前端已经计算好当时的总份额，后端直接使用
        const response = await api.createPoolNavRecord({
          poolId: pool_id,
          date: date,
          totalValue: total,
          totalShares: totalSharesAtDate  // 传递当时的总份额
        })

        if (response.success) {
          this.navSuccess = `✓ 成功更新池子 ${pool_id} 的净值！池子净值：${parseFloat(response.data.navValue).toFixed(2)}`

          // 清空表单
          this.navForm.pool_id = ''
          this.navForm.date = new Date().toISOString().split('T')[0]
          this.navForm.total = 0
          // 清空客户预览
          this.poolClientsPreview = []

          console.log('✅ 池子净值更新成功:', response.data)

          // 刷新客户列表以显示最新数据
          await this.loadClients(this.clientPagination.pageNumber)

          console.log('✅ 已刷新客户列表显示最新数据')
        } else {
          throw new Error(response.message || '更新净值失败')
        }
      } catch (e) {
        console.error('❌ 提交净值失败:', e)
        this.navError = e.response?.data?.message || e.message || '提交失败'
      }
    },
    async handleRollbackNav() {
      this.navError = ''
      this.navSuccess = ''

      const { pool_id } = this.navForm
      if (!pool_id) {
        this.navError = '请先选择要撤回的池子'
        return
      }

      // 获取该池子的最新更新日期
      const selectedPool = this.pools.find(p => p.pool_id === pool_id)
      if (!selectedPool || !selectedPool.lastNavUpdateDate) {
        this.navError = '该池子还没有净值更新记录，无法撤回'
        return
      }

      const lastUpdateDate = selectedPool.lastNavUpdateDate

      // 确认对话框
      if (!confirm(`确定要撤回池子 ${pool_id} 在 ${lastUpdateDate} 的净值更新吗？\n\n此操作将：\n1. 删除该日期的净值记录和所有客户快照\n2. 恢复池子和客户状态到前一天\n3. 此操作不可逆！`)) {
        return
      }

      try {
        console.log('🔄 开始撤回净值更新:', { poolId: pool_id, date: lastUpdateDate })

        const response = await api.rollbackNavUpdate(pool_id, lastUpdateDate)

        if (response.success) {
          this.navSuccess = `✓ 成功撤回池子 ${pool_id} 在 ${lastUpdateDate} 的净值更新！`

          // 重新加载池子列表
          await this.loadPools()

          // 清空客户预览
          this.poolClientsPreview = []

          // 刷新客户列表
          await this.loadClients(this.clientPagination.pageNumber)

          console.log('✅ 撤回成功，已刷新数据')
        } else {
          throw new Error(response.message || '撤回失败')
        }
      } catch (e) {
        console.error('❌ 撤回失败:', e)
        this.navError = e.response?.data?.message || e.message || '撤回失败'
      }
    },
    async handleCreateClient() {
      this.clientError = ''
      this.clientSuccess = ''

      const { client_id, name, email, phone, password, pool_id } = this.clientForm

      // 验证必填字段
      if (!client_id || !name || !email) {
        this.clientError = '请填写客户ID、姓名和邮箱'
        return
      }

      // 如果填写了手机号，验证手机号格式（中国大陆手机号）
      if (phone) {
        const phoneRegex = /^1[3-9]\d{9}$/
        if (!phoneRegex.test(phone)) {
          this.clientError = '请输入正确的手机号格式（11位数字，以1开头）'
          return
        }
      }

      try {
        if (this.editingClientId) {
          // 更新现有客户
          const client = this.clientsList.find(c => c.client_id === this.editingClientId)
          if (!client) {
            this.clientError = '客户不存在'
            return
          }

          const response = await api.updateClient(client.id, {
            clientId: client_id,
            name,
            email,
            phone: phone || null,
            balance: client.balance
          })

          if (response.success) {
            this.clientSuccess = `✓ 成功更新客户 ${client_id}`
            await this.loadClients() // 刷新客户列表
            this.cancelEditClient() // 清空表单
          } else {
            this.clientError = response.message || '更新客户失败'
          }
        } else {
          // 创建新客户 - 创建时手机号必填
          if (!phone) {
            this.clientError = '创建客户时手机号为必填项'
            return
          }

          const response = await api.createClient({
            clientId: client_id,
            name,
            email,
            phone,
            balance: 0,
            createUser: this.clientForm.createUser,  // 使用复选框的值
            password: password || '123456'  // 使用自定义密码或默认密码
          })

          if (response.success) {
            const userMsg = this.clientForm.createUser ? '，并已创建用户账号' : ''
            this.clientSuccess = `✓ 成功创建客户 ${client_id}${userMsg}`
            await this.loadClients() // 刷新客户列表
          } else {
            this.clientError = response.message || '创建客户失败'
          }
        }

        // 清空表单和编辑状态
        this.clientForm = { client_id: '', name: '', email: '', phone: '', password: '', pool_id: '', createUser: false }
        this.editingClientId = null
      } catch (e) {
        console.error('❌ 创建/更新客户失败:', e)
        this.clientError = e.response?.data?.message || e.message || '操作失败'
      }
    },
    editClient(client) {
      // 填充表单数据
      // 如果客户有多个池子，取第一个；如果没有池子，设为空字符串
      const poolId = client.pools !== '-' ? client.pools.split(',')[0].trim() : ''

      this.clientForm = {
        client_id: client.client_id,
        name: client.name,
        email: client.email,
        phone: client.phone || '',
        password: '',
        pool_id: poolId,
        createUser: !!client.user_id  // 如果有 user_id，说明已经创建了用户
      }
      this.editingClientId = client.client_id
      this.clientError = ''
      this.clientSuccess = ''

      // 滚动到表单顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    cancelEditClient() {
      this.clientForm = { client_id: '', name: '', email: '', phone: '', password: '', pool_id: '', createUser: false }
      this.editingClientId = null
      this.clientError = ''
      this.clientSuccess = ''
    },
    async deleteClient(clientId) {
      if (!confirm(`确定要删除客户 ${clientId} 吗？`)) {
        return
      }

      try {
        const client = this.clientsList.find(c => c.client_id === clientId)
        if (!client) {
          this.clientError = '客户不存在'
          return
        }

        const response = await api.deleteClient(client.id)
        if (response.success) {
          this.clientSuccess = `✓ 成功删除客户 ${clientId}`

          // 计算删除后应该显示的页码
          let targetPage = this.clientPagination.pageNumber

          // 如果当前页只有1个客户,且不是第一页,则跳转到上一页
          if (this.clientsList.length === 1 && this.clientPagination.pageNumber > 0) {
            targetPage = this.clientPagination.pageNumber - 1
          }

          await this.loadClients(targetPage) // 刷新客户列表

          // 如果正在编辑这个客户，清空表单
          if (this.editingClientId === clientId) {
            this.cancelEditClient()
          }
        } else {
          this.clientError = response.message || '删除客户失败'
        }
      } catch (e) {
        console.error('❌ 删除客户失败:', e)
        this.clientError = e.response?.data?.message || e.message || '删除失败'
      }
    },
    // 金额调整相关方法
    openAdjustBalance(client) {
      this.adjustingClient = { ...client }
      this.adjustType = 'add'
      this.adjustAmount = 0
      this.adjustRemark = ''
      this.adjustPoolId = ''
      this.adjustNavValue = 1.0
      this.adjustError = ''
      this.showAdjustModal = true
    },
    closeAdjustModal() {
      this.showAdjustModal = false
      this.adjustingClient = null
      this.adjustType = 'add'
      this.adjustAmount = 0
      this.adjustRemark = ''
      this.adjustPoolId = ''
      this.adjustNavValue = 1.0
      this.adjustError = ''
    },
    // 加入池子相关方法
    openJoinPoolModal(client) {
      this.joiningClient = client
      this.joinPoolForm.poolId = ''
      this.joinPoolForm.joinDate = new Date().toISOString().split('T')[0]  // 重置为今天
      this.joinPoolForm.amount = 0
      this.joinPoolError = ''
      this.showJoinPoolModal = true
    },
    closeJoinPoolModal() {
      this.showJoinPoolModal = false
      this.joiningClient = null
      this.joinPoolForm.poolId = ''
      this.joinPoolForm.amount = 0
      this.joinPoolError = ''
    },
    calculateExpectedShares() {
      if (!this.joinPoolForm.poolId || !this.joinPoolForm.amount || this.joinPoolForm.amount <= 0) {
        return '0.000000'
      }
      const selectedPool = this.poolsList.find(p => p.poolId === this.joinPoolForm.poolId)
      if (!selectedPool) return '0.00'
      const navValue = selectedPool.currentNavValue || 1.0
      const shares = this.joinPoolForm.amount / navValue
      return shares.toFixed(2)
    },
    async confirmJoinPool() {
      try {
        this.joinPoolError = ''

        if (!this.joinPoolForm.poolId) {
          this.joinPoolError = '请选择池子'
          return
        }

        if (!this.joinPoolForm.joinDate) {
          this.joinPoolError = '请选择加入日期'
          return
        }

        if (!this.joinPoolForm.amount || this.joinPoolForm.amount <= 0) {
          this.joinPoolError = '请输入有效的投入金额'
          return
        }

        console.log('🔄 客户加入池子:', {
          clientId: this.joiningClient.id,
          poolId: this.joinPoolForm.poolId,
          joinDate: this.joinPoolForm.joinDate,
          amount: this.joinPoolForm.amount
        })

        const response = await api.joinPool(this.joiningClient.id, {
          poolId: this.joinPoolForm.poolId,
          joinDate: this.joinPoolForm.joinDate,
          amount: this.joinPoolForm.amount
        })

        if (response.success) {
          const action = this.isAddingInvestment ? '追加投入' : '加入池子'
          this.clientSuccess = `✓ 客户 ${this.joiningClient.name} 成功${action} ${this.joinPoolForm.poolId}，金额: ￥${this.joinPoolForm.amount}`
          await this.loadClients() // 刷新客户列表
          this.closeJoinPoolModal()
        } else {
          this.joinPoolError = response.message || '操作失败'
        }
      } catch (e) {
        console.error('❌ 加入池子失败:', e)
        this.joinPoolError = e.response?.data?.message || '加入池子失败，请稍后重试'
      }
    },
    // 赎回相关方法
    openRedeemModal(client) {
      this.redeemingClient = client
      this.redeemForm.amount = 0
      this.redeemError = ''
      this.showRedeemModal = true
    },
    closeRedeemModal() {
      this.showRedeemModal = false
      this.redeemingClient = null
      this.redeemForm.amount = 0
      this.redeemError = ''
    },
    calculateRedeemShares() {
      if (!this.redeemForm.amount || this.redeemForm.amount <= 0 || !this.redeemingClient) {
        return '0.000000'
      }
      const poolId = this.redeemingClient.pools
      if (!poolId || poolId === '-') return '0.000000'

      const selectedPool = this.poolsList.find(p => p.poolId === poolId)
      if (!selectedPool) return '0.00'

      const navValue = selectedPool.currentNavValue || 1.0
      const shares = this.redeemForm.amount / navValue
      return shares.toFixed(2)
    },
    async confirmRedeem() {
      try {
        this.redeemError = ''

        if (!this.redeemForm.amount || this.redeemForm.amount <= 0) {
          this.redeemError = '请输入有效的赎回金额'
          return
        }

        if (this.redeemForm.amount > (this.redeemingClient.balance || 0)) {
          this.redeemError = '赎回金额不能超过当前余额'
          return
        }

        console.log('🔄 客户赎回:', {
          clientId: this.redeemingClient.id,
          poolId: this.redeemingClient.pools,
          amount: this.redeemForm.amount
        })

        const response = await api.redeemFromPool(this.redeemingClient.id, {
          poolId: this.redeemingClient.pools,
          amount: this.redeemForm.amount
        })

        if (response.success) {
          this.clientSuccess = `✓ 客户 ${this.redeemingClient.name} 成功赎回 ￥${this.redeemForm.amount}`
          await this.loadClients() // 刷新客户列表
          this.closeRedeemModal()
        } else {
          this.redeemError = response.message || '赎回失败'
        }
      } catch (e) {
        console.error('❌ 赎回失败:', e)
        this.redeemError = e.response?.data?.message || '赎回失败，请稍后重试'
      }
    },
    calculateNewBalance() {
      if (!this.adjustingClient) return 0
      const currentBalance = this.adjustingClient.balance || 0
      if (this.adjustType === 'add') {
        return currentBalance + (this.adjustAmount || 0)
      } else {
        return currentBalance - (this.adjustAmount || 0)
      }
    },
    async handleAdjustBalance() {
      this.adjustError = ''

      // 验证
      if (!this.adjustAmount || this.adjustAmount <= 0) {
        this.adjustError = '请输入有效的调整金额'
        return
      }

      const newBalance = this.calculateNewBalance()
      if (newBalance < 0) {
        this.adjustError = '调整后金额不能为负数'
        return
      }

      try {
        const requestData = {
          amount: this.adjustAmount,
          type: this.adjustType === 'add' ? 'DEPOSIT' : 'WITHDRAW',
          remark: this.adjustRemark || `${this.adjustType === 'add' ? '增加' : '减少'}金额`
        }

        const response = await api.adjustClientBalance(this.adjustingClient.id, requestData)

        if (response.success) {
          const action = this.adjustType === 'add' ? '增加' : '减少'
          const successMsg = `✓ 成功${action}客户 ${this.adjustingClient.name} 的金额 ${this.formatCurrency(this.adjustAmount)}`
          this.clientSuccess = successMsg

          console.log(`💰 金额调整记录:`, {
            client_id: this.adjustingClient.client_id,
            name: this.adjustingClient.name,
            type: this.adjustType,
            amount: this.adjustAmount,
            oldBalance: this.adjustingClient.balance,
            newBalance: newBalance,
            remark: this.adjustRemark,
            timestamp: new Date().toISOString()
          })

          await this.loadClients() // 刷新客户列表
          this.closeAdjustModal()
        } else {
          this.adjustError = response.message || '调整金额失败'
        }
      } catch (e) {
        console.error('❌ 调整金额失败:', e)
        this.adjustError = e.response?.data?.message || e.message || '调整失败'
      }
    },
    // 加载池净值记录（分页）
    async loadPoolNavRecords(page = 0) {
      try {
        const response = await api.getAllNavRecords({
          page: page,
          size: this.poolNavPagination.pageSize,
          sortBy: 'date',
          sortDir: 'DESC'
        })

        if (response.success && response.data) {
          this.poolNavLogs = response.data.content
          this.poolNavPagination.pageNumber = response.data.number
          this.poolNavPagination.totalElements = response.data.totalElements
          this.poolNavPagination.totalPages = response.data.totalPages
          console.log('✅ 加载池净值记录成功')
        }
      } catch (error) {
        console.error('❌ 加载池净值记录失败:', error)
      }
    },
    // 刷新池净值记录
    async refreshPoolNavLogs() {
      await this.loadPoolNavRecords(0)
    },
    // 池净值记录分页操作
    goToPoolNavPage(page) {
      this.loadPoolNavRecords(page)
    },
    changePoolNavPageSize() {
      this.poolNavPagination.pageNumber = 0
      this.loadPoolNavRecords(0)
    },
    // 加载客户净值记录（分页）
    async loadClientNavRecords(page = 0) {
      try {
        const response = await api.getAllClientNavSnapshots({
          page: page,
          size: this.clientNavPagination.pageSize,
          sortBy: 'date',
          sortDir: 'DESC'
        })

        if (response.success && response.data) {
          this.clientNavLogs = response.data.content
          this.clientNavPagination.pageNumber = response.data.number
          this.clientNavPagination.totalElements = response.data.totalElements
          this.clientNavPagination.totalPages = response.data.totalPages
          console.log('✅ 加载客户净值记录成功')
        }
      } catch (error) {
        console.error('❌ 加载客户净值记录失败:', error)
      }
    },
    // 客户净值记录分页操作
    goToClientNavPage(page) {
      this.loadClientNavRecords(page)
    },
    changeClientNavPageSize() {
      this.clientNavPagination.pageNumber = 0
      this.loadClientNavRecords(0)
    },
    formatCurrency(value) {
      if (!value) return '$0.0'
      // 金额保留一位小数并四舍五入
      return '$' + parseFloat(value).toFixed(1)
    },
    // 格式化份额
    formatShares(value) {
      if (value === null || value === undefined || value === 0) return '-'
      return value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style scoped>
.admin-page {
  min-height: 100vh;
  background: var(--bg);
}

.header {
  background: var(--card);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 100;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-badge {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, var(--primary) 0%, #7b9eff 100%);
  color: #fff;
  font-weight: 700;
  font-size: 18px;
}

h1 {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.muted {
  color: var(--muted);
  font-size: 13px;
  margin-top: 2px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-email {
  color: var(--muted);
  font-size: 14px;
}

.btn-secondary {
  height: 36px;
  padding: 0 16px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-secondary:hover {
  border-color: var(--primary);
  color: var(--primary);
}

.main-content {
  padding: 32px 0;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Tabs */
.tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 0;
}

.tab-btn {
  padding: 12px 20px;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--muted);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.tab-btn.active {
  color: var(--primary);
  border-bottom-color: var(--primary);
}

.tab-btn:hover {
  color: var(--text);
}

/* Tab Content */
.tab-panel {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 32px;
}

.panel-header {
  margin-bottom: 32px;
}

.panel-header h2 {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 8px;
  color: var(--text);
}

.panel-desc {
  font-size: 14px;
  color: var(--muted);
  margin: 0;
}

/* Forms */
.form-section {
  margin-bottom: 32px;
}

.form-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-field label {
  font-size: 13px;
  font-weight: 500;
  color: var(--muted);
}

.form-field .checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--text);
}

.form-field .checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.form-field .checkbox-label span {
  user-select: none;
}

.input {
  height: 44px;
  padding: 0 14px;
  background: var(--input);
  border: 1px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 14px;
  transition: all 0.2s;
}

.input:focus {
  outline: none;
  border-color: var(--primary);
}

.input-sm {
  height: 36px;
  padding: 0 10px;
  background: var(--input);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text);
  font-size: 13px;
  width: 100%;
}

.field-hint {
  font-size: 12px;
  color: var(--muted);
  margin-top: 4px;
}

/* Members Section */
.members-section {
  margin-bottom: 32px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-header h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: var(--text);
}

.btn-add {
  height: 36px;
  padding: 0 16px;
  background: var(--primary);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-add:hover {
  background: var(--primary-press);
}

.members-table {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background: var(--card-2);
  padding: 12px;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted);
  border-bottom: 1px solid var(--border);
}

td {
  padding: 12px;
  border-bottom: 1px solid var(--border);
}

.btn-delete {
  height: 32px;
  padding: 0 12px;
  background: transparent;
  border: 1px solid var(--danger);
  border-radius: 6px;
  color: var(--danger);
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-delete:hover {
  background: var(--danger);
  color: #fff;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary {
  height: 44px;
  padding: 0 24px;
  background: var(--primary);
  border: none;
  border-radius: 8px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  background: var(--primary-press);
}

.btn-danger {
  height: 44px;
  padding: 0 24px;
  background: transparent;
  border: 1px solid var(--danger);
  border-radius: 8px;
  color: var(--danger);
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-danger:hover {
  background: var(--danger);
  color: #fff;
}

/* Alerts */
.alert {
  margin-top: 20px;
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 14px;
}

.alert-error {
  background: rgba(255, 107, 107, 0.1);
  border: 1px solid rgba(255, 107, 107, 0.3);
  color: #ffb3b3;
}

.alert-success {
  background: rgba(74, 222, 128, 0.1);
  border: 1px solid rgba(74, 222, 128, 0.3);
  color: #86efac;
}

/* Preview & Records */
.preview-section,
.records-section {
  margin-top: 32px;
}

.preview-section h3,
.records-section h3 {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 16px;
  color: var(--text);
}

.table-container {
  overflow-x: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
}

.clients-list {
  margin-top: 32px;
}

@media (max-width: 768px) {
  /* Header 移动端适配 */
  .header-content {
    padding: 12px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .brand {
    width: 100%;
  }

  .brand-badge {
    width: 36px;
    height: 36px;
    font-size: 16px;
  }

  h1 {
    font-size: 16px;
  }

  .muted {
    font-size: 12px;
  }

  .header-actions {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  .user-email {
    font-size: 13px;
    flex: 1;
  }

  .btn-secondary {
    font-size: 13px;
    padding: 8px 16px;
    height: auto;
    white-space: nowrap;
  }

  /* Main Content */
  .main-content {
    padding: 16px 0;
  }

  .container {
    padding: 0 16px;
  }

  /* Tabs */
  .tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    gap: 4px;
    margin-bottom: 16px;
  }

  .tab-btn {
    padding: 10px 16px;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
  }

  /* Tab Panel */
  .tab-panel {
    padding: 16px;
  }

  .panel-header h2 {
    font-size: 18px;
  }

  .panel-desc {
    font-size: 13px;
  }

  /* Form */
  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .form-field label {
    font-size: 13px;
  }

  .input,
  .input-sm {
    font-size: 14px;
    height: 44px;
  }

  select.input {
    height: 44px;
  }

  /* Buttons */
  .btn-primary,
  .btn-add {
    width: 100%;
    height: 44px;
    font-size: 14px;
  }

  .form-actions {
    flex-direction: column;
    gap: 12px;
  }

  .form-actions .btn-primary,
  .form-actions .btn-secondary {
    width: 100%;
    height: 44px;
  }

  /* Tables */
  .members-table,
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    min-width: 800px;
    font-size: 13px;
  }

  th {
    padding: 10px 8px;
    font-size: 11px;
    white-space: nowrap;
  }

  td {
    padding: 10px 8px;
    font-size: 12px;
  }

  /* Client Preview Cards */
  .client-preview-card {
    padding: 12px;
  }

  .client-preview-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .client-preview-stats {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  /* Pool Cards */
  .pool-card {
    padding: 16px;
  }

  .pool-header h3 {
    font-size: 16px;
  }

  .pool-stats {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  /* Action Buttons */
  .action-buttons {
    gap: 6px;
  }

  .btn-edit,
  .btn-adjust,
  .btn-join-pool,
  .btn-add-investment,
  .btn-redeem,
  .btn-delete,
  .btn-rollback {
    font-size: 12px;
    padding: 0 10px;
    height: 36px;
  }

  /* Pagination */
  .pagination {
    flex-direction: column;
    gap: 12px;
  }

  .page-btn {
    width: 100%;
    height: 40px;
  }

  .page-info {
    font-size: 12px;
    text-align: center;
  }

  /* Date Filter */
  .date-filter {
    flex-direction: column;
    gap: 12px;
  }

  .date-filter label {
    font-size: 13px;
  }

  .date-input {
    width: 100%;
    height: 44px;
    font-size: 14px;
  }

  .reset-btn {
    width: 100%;
    height: 44px;
  }

  /* Success/Error Messages */
  .success-message,
  .error-message {
    font-size: 13px;
    padding: 12px;
  }

  /* Section Headers */
  .section-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .section-header h3 {
    font-size: 16px;
  }

  /* Preview Section - 客户预览 */
  .preview-section {
    margin-top: 24px;
  }

  .preview-section h3 {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .total-summary {
    flex-direction: column;
    gap: 12px;
    padding: 16px;
  }

  .summary-item {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid var(--border);
  }

  .summary-item:last-child {
    border-bottom: none;
  }

  .summary-label {
    font-size: 13px;
  }

  .summary-value {
    font-size: 16px;
  }

  .summary-value.primary,
  .summary-value.warning,
  .summary-value.highlight {
    font-size: 18px;
  }

  .preview-table {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .preview-table table {
    min-width: 700px;
  }

  /* Form Actions - 按钮组 */
  .form-actions {
    flex-direction: column;
    gap: 12px;
    margin-top: 24px;
  }

  .form-actions .btn-primary,
  .form-actions .btn-danger,
  .form-actions .btn-secondary {
    width: 100%;
    height: 44px;
    margin: 0 !important;
    font-size: 14px;
  }

  .btn-danger {
    order: 2;
  }

  .btn-primary {
    order: 1;
  }
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-edit,
.btn-adjust,
.btn-join-pool,
.btn-add-investment,
.btn-redeem,
.btn-delete {
  height: 32px;
  padding: 0 12px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit {
  background: rgba(79, 158, 255, 0.15);
  color: var(--primary);
}

.btn-edit:hover {
  background: rgba(79, 158, 255, 0.25);
}

.btn-join-pool {
  background: rgba(168, 85, 247, 0.15);
  color: #a855f7;
}

.btn-join-pool:hover {
  background: rgba(168, 85, 247, 0.25);
}

.btn-add-investment {
  background: rgba(251, 146, 60, 0.15);
  color: #f97316;
}

.btn-add-investment:hover {
  background: rgba(251, 146, 60, 0.25);
}

.btn-redeem {
  background: rgba(239, 68, 68, 0.15);
  color: #ef4444;
}

.btn-redeem:hover {
  background: rgba(239, 68, 68, 0.25);
}

.btn-adjust {
  background: rgba(74, 222, 128, 0.15);
  color: #4ade80;
}

.btn-adjust:hover {
  background: rgba(74, 222, 128, 0.25);
}

.btn-delete {
  background: rgba(255, 107, 107, 0.15);
  color: #ff6b6b;
}

.btn-delete:hover {
  background: rgba(255, 107, 107, 0.25);
}

.form-actions .btn-secondary {
  height: 44px;
  padding: 0 24px;
  font-size: 15px;
  font-weight: 600;
}

/* 金额显示 */
.balance-amount {
  font-weight: 600;
  color: var(--primary);
  font-size: 14px;
}

/* 模态框 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 16px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border);
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
}

.modal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: var(--muted);
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 6px;
}

.modal-close:hover {
  background: var(--card-2);
  color: var(--text);
}

.modal-body {
  padding: 24px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border);
  justify-content: flex-end;
}

.client-info-display,
.info-display {
  background: var(--card-2);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.client-info-display p,
.info-display p {
  margin: 8px 0;
  font-size: 14px;
  color: var(--text);
}

.client-info-display strong,
.info-display strong {
  color: var(--muted);
  margin-right: 8px;
}

.adjust-type-buttons {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 8px;
}

.type-btn {
  height: 44px;
  padding: 0 16px;
  background: var(--card-2);
  border: 2px solid var(--border);
  border-radius: 8px;
  color: var(--text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.type-btn:hover {
  border-color: var(--primary);
}

.type-btn.active {
  background: rgba(79, 158, 255, 0.15);
  border-color: var(--primary);
  color: var(--primary);
}

.preview-result {
  background: var(--card-2);
  padding: 16px;
  border-radius: 8px;
  margin-top: 16px;
}

/* 搜索和分页样式 */
.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.search-box {
  position: relative;
  width: 300px;
}

.search-input {
  width: 100%;
  padding-right: 40px;
}

.btn-clear {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: none;
  background: var(--muted);
  color: white;
  border-radius: 50%;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

.btn-clear:hover {
  background: var(--danger);
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 24px;
  padding: 20px 0;
  border-top: 1px solid var(--border);
}

.pagination-btn {
  height: 36px;
  padding: 0 16px;
  background: var(--card-2);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-info {
  color: var(--muted);
  font-size: 14px;
  margin: 0 8px;
}

.page-size-select {
  height: 36px;
  padding: 0 12px;
  background: var(--card-2);
  border: 1px solid var(--border);
  border-radius: 6px;
  color: var(--text);
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}

.page-size-select:hover {
  border-color: var(--primary);
}

.preview-result p {
  margin: 0;
  font-size: 15px;
  color: var(--text);
}

.preview-result strong {
  color: var(--muted);
  margin-right: 8px;
}

/* 总金额统计样式 */
.total-summary {
  display: flex;
  gap: 24px;
  padding: 16px 20px;
  margin-bottom: 16px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.08) 0%, rgba(168, 85, 247, 0.08) 100%);
  border-radius: 8px;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.summary-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.summary-label {
  color: var(--muted);
  font-size: 14px;
  font-weight: 500;
}

.summary-value {
  color: var(--text);
  font-size: 18px;
  font-weight: 600;
}

.summary-value.primary {
  color: var(--primary);
  font-size: 20px;
}

.summary-value.warning {
  color: #f59e0b;
  font-size: 20px;
  font-weight: 600;
}

.summary-value.highlight {
  color: #10b981;
  font-size: 22px;
  font-weight: 700;
}

.preview-result .positive {
  color: #4ade80;
  font-weight: 600;
  font-size: 16px;
}

.preview-result .negative {
  color: #ff6b6b;
  font-weight: 600;
  font-size: 16px;
}

textarea.input {
  resize: vertical;
  font-family: inherit;
}
</style>

